/**
 * @template T
 * @param {T[]} arr
 * @param {T} ele
 */
export function sortedSetAdd(arr, ele) {
	const res = sortedSetSearch(arr, ele);
	if (res.included) return arr;
	else return arr.toSpliced(res.index, 0, ele);
}

/**
 * @template T
 * @param {T[]} arr
 * @param {T} ele
 */
export function sortedSetDelete(arr, ele) {
	const res = sortedSetSearch(arr, ele);
	if (res.included) return arr.toSpliced(res.index, 1);
	else return arr;
}

/**
 * @template T
 * @param {T[]} arr
 * @param {T} ele
 */
export function sortedSetIncludes(arr, ele) {
	return sortedSetSearch(arr, ele).included;
}

/**
 * @template T
 * @param {T[]} arr
 * @param {T} ele
 */
function sortedSetSearch(arr, ele) {
	let low = 0;
	let high = arr.length - 1;

	while (low <= high) {
		const mid = Math.floor((low + high) / 2);
		if (arr[mid] === ele) {
			return { index: mid, included: true };
		} else if (arr[mid] < ele) {
			low = mid + 1;
		} else {
			high = mid - 1;
		}
	}

	return { index: low, included: false };
}
